import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';
import { TStyleConfig } from '../../base/types';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,
      readableColor: 'white',
      borderBottom: 'white',
      bottomBorderRadius: base.borderBottomRadius,
      background: {
        bg: ['gamma.500', 'gamma.500', null, 'betaAlpha.300'],
        boxShadow: 'inset 0px 1px 4px #5171ae, inset 0px 1px 1px #404c94',
        borderRadius: [null, null, null, 'lg'],
        alignSelf: [null, null, null, 'flex-start'],
        overflow: 'hidden',
        mt: ['53px', '110px', null, '0px'],
        mb: '3',
      },
      drawer: {
        ...base.drawer,
      },
      drawerBody: {
        '> div, a': {
          color: 'white',
          ml: '2',

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              borderColor: 'transparent',
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
      },
      icon: {
        ...base.icon,
        boxSize: '20px',
        color: 'alpha.500',
      },
      headerSX: {
        cursor: 'default',
        color: 'alpha.500',
        height: '45px',
        borderColor: 'transparent',
        '&:hover': {
          borderColor: 'transparent',
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
        px: '4',
      },
      linkSX: {
        ...base.linkSX,
        mb: [null, null, null, '4'],
      },
      link: {
        ...base.link,

        fontSize: 'sm',
        fontWeight: 'bold',
        height: '43px',
        color: 'white',
        transition: 'all, 0.2s linear',
        borderLeftWidth: '3px',
        borderColor: 'transparent',
        p: '4',

        '~ .nested': {
          pl: '10',
        },

        ':hover': {
          borderColor: 'alpha.500',
          bg: 'betaAlpha.500',
        },
        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'alpha.500',
          transition: 'all, 0.2s linear',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          pl: ['6', null, '4'],
        },

        '> a, .dropDownIcon, a': {
          color: 'white',
        },

        '&:hover, &:active': {
          color: ['white', null, null, 'gamma.500'],

          '.dropDownInner': {
            ...base.dropDownInner,
            px: '4',
            color: ['white'],
          },

          '.svgIcon, .icon': {
            color: ['alpha.500', 'alpha.500'],
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        p: '0',
        color: ['white', null, null, 'gamma.500'],
        '.dropDownInner': {
          bg: 'betaAlpha.500',
          borderLeftWidth: '3px',
          borderColor: 'alpha.500',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'alpha.500',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
